<template>
  <div class="service">
    <div class="service-top">
      <div class="service-top__title">服务供应商信息</div>
      <div class="service-top__right">
        <div class="service-top__name">创建日期:</div>
        <el-date-picker
          v-model="searchData.time"
          size="mini"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"></el-date-picker>
        <el-input size="mini" class="service-top__input" v-model="searchData.text" placeholder="供应商名称/ID/地址/联系人等"></el-input>
        <div class="service-top__btn">搜索</div>
        <div class="service-top__btn" @click="newServiceSupplierBtnClick">新建服务供应商</div>
      </div>
    </div>
    <div class="service-table">
      <Table :head="tableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ServiceSupplierSearchData, ServiceSupplierInputBoxNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'serviceSupplierInfo',
  components: {
    Table
  },
  data(){
    return {
      searchData: new ServiceSupplierSearchData(),
      tableHead: ServiceSupplierInputBoxNewModule.NEWTABLEHEAD()
    }
  },
  methods:{
    /**新建服务供应商 */
    newServiceSupplierBtnClick(){
      this.$emit('go', {
        id: 'newServiceSupplier',
        name: '新建服务供应商',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.service{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__title{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    ::v-deep{
      .el-range-separator{
        z-index: 1;
      }
      .el-range-input{
        width: 100px;
      }
      .el-input__inner{
        width: 250px;
      }
      .el-input{
        width: 250px;
        margin: 0 10px;
      }
    }
    &__right{
      display: flex;
      align-items: center;
    }
    &__btn{
      padding: 6px 20px;
      background: #00a0c7;
      color: white;
      margin-left: 5px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
